import { useEffect } from "react";

import { useDashboardCard } from "../../Contexts/DashboardCardContext";
import { MachinePositionsMapView } from "../../Map/MachinePositionsMapView";

export const MachinePositionsCard: React.FC = () => {
  const { reportLive } = useDashboardCard();

  useEffect(() => {
    reportLive({ current: true, tooltipText: "Receiving live position updates" });
  }, [reportLive]);

  return (
    <div className="w-full h-full min-h-0 flex flex-col gap-3 p-3">
      <MachinePositionsMapView sitePlanOption={false} />
    </div>
  );
};
